// src/i18n/index.js — init i18next (S1, shell only)
// Voir docs/PLAN_I18N_MULTILANGUE.md §6.
//
// Choix S1 : ressources EMBARQUÉES statiquement (4 petits namespaces × 3 langues).
// → init SYNCHRONE, la langue initiale est résolue avant le 1er render → PAS de
// flash FR→EN. Le lazy-load par namespace viendra en S2/S3 quand le volume grossit.
//
// Langue initiale = localStorage ('terrilink_lang') normalisé, sinon 'fr'.
// La réconciliation avec la préférence membre + les langues du tenant se fait
// ensuite dans LanguageContext (sans flash pour le cas courant).

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { normalizeLocale } from '../utils/locales'

import frCommon from './locales/fr/common.json'
import frNav from './locales/fr/nav.json'
import frGlossary from './locales/fr/glossary.json'
import frBusiness from './locales/fr/business.json'
import frNotifications from './locales/fr/notifications.json'
import frForms from './locales/fr/forms.json'
import frThemes from './locales/fr/themes.json'
import frSettings from './locales/fr/settings.json'
import frDashboard from './locales/fr/dashboard.json'
import frMembers from './locales/fr/members.json'
import frEvents from './locales/fr/events.json'
import frMap from './locales/fr/map.json'
import frJobs from './locales/fr/jobs.json'
import frPosts from './locales/fr/posts.json'
import frDiscussions from './locales/fr/discussions.json'
import frMentoring from './locales/fr/mentoring.json'
import frRcp from './locales/fr/rcp.json'
import frRecruiter from './locales/fr/recruiter.json'
import frAnalytics from './locales/fr/analytics.json'
import frEducation from './locales/fr/education.json'
import frBilling from './locales/fr/billing.json'
import frHelp from './locales/fr/help.json'
import frClubMeetings from './locales/fr/clubMeetings.json'
import frRadar from './locales/fr/radar.json'
import frCalendar from './locales/fr/calendar.json'
import frMessaging from './locales/fr/messaging.json'
import enCommon from './locales/en/common.json'
import enNav from './locales/en/nav.json'
import enGlossary from './locales/en/glossary.json'
import enBusiness from './locales/en/business.json'
import enNotifications from './locales/en/notifications.json'
import enForms from './locales/en/forms.json'
import enThemes from './locales/en/themes.json'
import enSettings from './locales/en/settings.json'
import enDashboard from './locales/en/dashboard.json'
import enMembers from './locales/en/members.json'
import enEvents from './locales/en/events.json'
import enMap from './locales/en/map.json'
import enJobs from './locales/en/jobs.json'
import enPosts from './locales/en/posts.json'
import enDiscussions from './locales/en/discussions.json'
import enMentoring from './locales/en/mentoring.json'
import enRcp from './locales/en/rcp.json'
import enRecruiter from './locales/en/recruiter.json'
import enAnalytics from './locales/en/analytics.json'
import enEducation from './locales/en/education.json'
import enBilling from './locales/en/billing.json'
import enHelp from './locales/en/help.json'
import enClubMeetings from './locales/en/clubMeetings.json'
import enRadar from './locales/en/radar.json'
import enCalendar from './locales/en/calendar.json'
import enMessaging from './locales/en/messaging.json'
import esCommon from './locales/es/common.json'
import esNav from './locales/es/nav.json'
import esGlossary from './locales/es/glossary.json'
import esBusiness from './locales/es/business.json'
import esNotifications from './locales/es/notifications.json'
import esForms from './locales/es/forms.json'
import esThemes from './locales/es/themes.json'
import esSettings from './locales/es/settings.json'
import esDashboard from './locales/es/dashboard.json'
import esMembers from './locales/es/members.json'
import esEvents from './locales/es/events.json'
import esMap from './locales/es/map.json'
import esJobs from './locales/es/jobs.json'
import esPosts from './locales/es/posts.json'
import esDiscussions from './locales/es/discussions.json'
import esMentoring from './locales/es/mentoring.json'
import esRcp from './locales/es/rcp.json'
import esRecruiter from './locales/es/recruiter.json'
import esAnalytics from './locales/es/analytics.json'
import esEducation from './locales/es/education.json'
import esBilling from './locales/es/billing.json'
import esHelp from './locales/es/help.json'
import esClubMeetings from './locales/es/clubMeetings.json'
import esRadar from './locales/es/radar.json'
import esCalendar from './locales/es/calendar.json'
import esMessaging from './locales/es/messaging.json'
import itCommon from './locales/it/common.json'
import itNav from './locales/it/nav.json'
import itGlossary from './locales/it/glossary.json'
import itBusiness from './locales/it/business.json'
import itNotifications from './locales/it/notifications.json'
import itForms from './locales/it/forms.json'
import itThemes from './locales/it/themes.json'
import itSettings from './locales/it/settings.json'
import itDashboard from './locales/it/dashboard.json'
import itMembers from './locales/it/members.json'
import itEvents from './locales/it/events.json'
import itMap from './locales/it/map.json'
import itJobs from './locales/it/jobs.json'
import itPosts from './locales/it/posts.json'
import itDiscussions from './locales/it/discussions.json'
import itMentoring from './locales/it/mentoring.json'
import itRcp from './locales/it/rcp.json'
import itRecruiter from './locales/it/recruiter.json'
import itAnalytics from './locales/it/analytics.json'
import itEducation from './locales/it/education.json'
import itBilling from './locales/it/billing.json'
import itHelp from './locales/it/help.json'
import itClubMeetings from './locales/it/clubMeetings.json'
import itRadar from './locales/it/radar.json'
import itCalendar from './locales/it/calendar.json'
import itMessaging from './locales/it/messaging.json'
import ptCommon from './locales/pt/common.json'
import ptNav from './locales/pt/nav.json'
import ptGlossary from './locales/pt/glossary.json'
import ptBusiness from './locales/pt/business.json'
import ptNotifications from './locales/pt/notifications.json'
import ptForms from './locales/pt/forms.json'
import ptThemes from './locales/pt/themes.json'
import ptSettings from './locales/pt/settings.json'
import ptDashboard from './locales/pt/dashboard.json'
import ptMembers from './locales/pt/members.json'
import ptEvents from './locales/pt/events.json'
import ptMap from './locales/pt/map.json'
import ptJobs from './locales/pt/jobs.json'
import ptPosts from './locales/pt/posts.json'
import ptDiscussions from './locales/pt/discussions.json'
import ptMentoring from './locales/pt/mentoring.json'
import ptRcp from './locales/pt/rcp.json'
import ptRecruiter from './locales/pt/recruiter.json'
import ptAnalytics from './locales/pt/analytics.json'
import ptEducation from './locales/pt/education.json'
import ptBilling from './locales/pt/billing.json'
import ptHelp from './locales/pt/help.json'
import ptClubMeetings from './locales/pt/clubMeetings.json'
import ptRadar from './locales/pt/radar.json'
import ptCalendar from './locales/pt/calendar.json'
import ptMessaging from './locales/pt/messaging.json'

export const STORAGE_KEY = 'terrilink_lang'

const resources = {
  fr: { common: frCommon, nav: frNav, glossary: frGlossary, business: frBusiness, notifications: frNotifications, forms: frForms, themes: frThemes, settings: frSettings, dashboard: frDashboard, members: frMembers, events: frEvents, map: frMap, jobs: frJobs, posts: frPosts, discussions: frDiscussions, mentoring: frMentoring, rcp: frRcp, recruiter: frRecruiter, analytics: frAnalytics, education: frEducation, billing: frBilling, help: frHelp, clubMeetings: frClubMeetings, radar: frRadar, calendar: frCalendar, messaging: frMessaging },
  en: { common: enCommon, nav: enNav, glossary: enGlossary, business: enBusiness, notifications: enNotifications, forms: enForms, themes: enThemes, settings: enSettings, dashboard: enDashboard, members: enMembers, events: enEvents, map: enMap, jobs: enJobs, posts: enPosts, discussions: enDiscussions, mentoring: enMentoring, rcp: enRcp, recruiter: enRecruiter, analytics: enAnalytics, education: enEducation, billing: enBilling, help: enHelp, clubMeetings: enClubMeetings, radar: enRadar, calendar: enCalendar, messaging: enMessaging },
  es: { common: esCommon, nav: esNav, glossary: esGlossary, business: esBusiness, notifications: esNotifications, forms: esForms, themes: esThemes, settings: esSettings, dashboard: esDashboard, members: esMembers, events: esEvents, map: esMap, jobs: esJobs, posts: esPosts, discussions: esDiscussions, mentoring: esMentoring, rcp: esRcp, recruiter: esRecruiter, analytics: esAnalytics, education: esEducation, billing: esBilling, help: esHelp, clubMeetings: esClubMeetings, radar: esRadar, calendar: esCalendar, messaging: esMessaging },
  it: { common: itCommon, nav: itNav, glossary: itGlossary, business: itBusiness, notifications: itNotifications, forms: itForms, themes: itThemes, settings: itSettings, dashboard: itDashboard, members: itMembers, events: itEvents, map: itMap, jobs: itJobs, posts: itPosts, discussions: itDiscussions, mentoring: itMentoring, rcp: itRcp, recruiter: itRecruiter, analytics: itAnalytics, education: itEducation, billing: itBilling, help: itHelp, clubMeetings: itClubMeetings, radar: itRadar, calendar: itCalendar, messaging: itMessaging },
  pt: { common: ptCommon, nav: ptNav, glossary: ptGlossary, business: ptBusiness, notifications: ptNotifications, forms: ptForms, themes: ptThemes, settings: ptSettings, dashboard: ptDashboard, members: ptMembers, events: ptEvents, map: ptMap, jobs: ptJobs, posts: ptPosts, discussions: ptDiscussions, mentoring: ptMentoring, rcp: ptRcp, recruiter: ptRecruiter, analytics: ptAnalytics, education: ptEducation, billing: ptBilling, help: ptHelp, clubMeetings: ptClubMeetings, radar: ptRadar, calendar: ptCalendar, messaging: ptMessaging },
}

const initialLng = normalizeLocale(
  typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null,
)

i18n.use(initReactI18next).init({
  resources,
  lng: initialLng,
  fallbackLng: 'fr',
  ns: ['common', 'nav', 'glossary', 'business', 'notifications', 'forms', 'themes', 'settings', 'dashboard', 'members', 'events', 'map', 'jobs', 'posts', 'discussions', 'mentoring', 'rcp', 'recruiter', 'analytics', 'education', 'billing', 'help', 'clubMeetings', 'radar', 'calendar', 'messaging'],
  defaultNS: 'common',
  interpolation: { escapeValue: false }, // React échappe déjà
  returnNull: false,
})

// ── Attribut lang du document ──────────────────────────────────────────────
// index.html déclarait `lang="en"` en dur alors que l'interface est servie en
// français dans l'immense majorité des cas. Chrome sur Android en déduit une
// page à traduire, Google Translate remplace les nœuds de texte, et React
// échoue ensuite à insérer ou retirer un nœud qui n'est plus le sien
// (NotFoundError insertBefore / removeChild, remontés par Sentry en
// production, surtout sur le fil de messagerie où l'insertion est continue).
//
// L'attribut suit désormais la langue active, ce qui supprime le faux
// déclenchement à la racine. `translate="no"` dans index.html couvre le cas où
// l'utilisateur demanderait quand même la traduction.
const syncDocumentLang = (lng) => {
  if (typeof document === 'undefined') return
  document.documentElement.setAttribute('lang', normalizeLocale(lng))
}

syncDocumentLang(i18n.language || initialLng)
i18n.on('languageChanged', syncDocumentLang)

export default i18n
